module.exports = __webpack_public_path__ + "static/media/Weekyn_logo_white_sm.97f69813.png";